export default "__VITE_ASSET__CQG$1ZlE__"